import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-home-header',
  imports: [RouterLink, FormsModule, TranslatePipe],
  templateUrl: './home-header.html',
  styleUrl: './home-header.scss',
})
export class HomeHeader implements OnInit {
  searchQuery: string = '';
  searchHistory: string[] = [];
  showHistory: boolean = false;

  // Quick search translation keys
  quickSearchKeys = {
    furnished: 'home.header.quickSearchOptions.furnished',
    studio: 'home.header.quickSearchOptions.studio',
    chalet: 'home.header.quickSearchOptions.chalet',
  };

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.loadSearchHistory();
  }

  loadSearchHistory(): void {
    const history = localStorage.getItem('homigo_search_history');
    if (history) {
      try {
        this.searchHistory = JSON.parse(history);
      } catch (e) {
        this.searchHistory = [];
      }
    }
  }

  saveToSearchHistory(query: string): void {
    if (!query) return;
    
    // Remove if already exists (case-insensitive) to move it to top
    const lowerQuery = query.toLowerCase();
    this.searchHistory = this.searchHistory.filter(h => h.toLowerCase() !== lowerQuery);
    
    // Add to beginning
    this.searchHistory.unshift(query);
    
    // Keep max 4 items
    if (this.searchHistory.length > 4) {
      this.searchHistory = this.searchHistory.slice(0, 4);
    }
    
    localStorage.setItem('homigo_search_history', JSON.stringify(this.searchHistory));
  }

  onSearch(event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    const title = this.searchQuery.trim();

    if (title) {
      this.saveToSearchHistory(title);
    }

    // Navigate to all-properties with title query param
    this.router.navigate(['/all-properties'], {
      queryParams: title ? { title } : {},
    });

    this.showHistory = false;
  }

  quickSearch(query: string): void {
    this.searchQuery = query;
    this.onSearch();
  }

  selectHistoryItem(item: string): void {
    this.searchQuery = item;
    this.onSearch();
  }

  onFocus(): void {
    this.showHistory = true;
  }

  onBlur(): void {
    // Small delay to allow click event on history items to fire
    setTimeout(() => {
      this.showHistory = false;
    }, 200);
  }
}
